import api from './api';

export interface PublicDeck {
  _id: string;
  name: string;
  description: string;
  slug?: string;
  tags: string[];
  cardCount: number;
  studyCount: number;
  createdAt: string;
  updatedAt: string;
  creatorEmail: string;
  creatorName: string;
}

export interface PublicDeckDetail extends PublicDeck {
  lastStudied?: string;
  status: string;
  canonicalUrl: string;
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string[];
}

export interface PublicCard {
  _id: string;
  front: string;
  back: string;
  difficulty: number;
  tags: string[];
  createdAt: string;
  updatedAt: string;
}

export interface DeckSearchQuery {
  q?: string;
  tags?: string;
  page?: number;
  limit?: number;
}

export interface DeckSearchResponse {
  decks: PublicDeck[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface DeckSeoMeta {
  title: string;
  description: string;
  keywords: string[];
  canonicalUrl: string;
  ogImage: string;
  ogType: string;
  ogSiteName: string;
  ogLocale: string;
  authorName: string;
  structuredData: any;
}

const publicDeckService = {
  searchDecks: async (query: DeckSearchQuery): Promise<DeckSearchResponse> => {
    const params = new URLSearchParams();
    
    params.append('type', 'decks');
    if (query.q) params.append('q', query.q);
    if (query.tags) params.append('tags', query.tags);
    if (query.page) params.append('page', query.page.toString());
    if (query.limit) params.append('limit', query.limit.toString());

    const response = await api.get(`/public/search?${params.toString()}`);
    return response.data;
  },

  getDeckById: async (id: string): Promise<PublicDeckDetail> => {
    const response = await api.get(`/public/decks/${id}`);
    return response.data;
  },

  getDeckCards: async (id: string): Promise<PublicCard[]> => {
    const response = await api.get(`/public/decks/${id}/cards`);
    return response.data;
  },

  getDeckSeoData: async (id: string): Promise<DeckSeoMeta> => {
    const response = await api.get(`/public/decks/${id}/seo`);
    return response.data;
  }
};

export default publicDeckService;